var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinentEuropeCountryitaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1900_45919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 17.9999C24 18.7072 23.719 19.3854 23.219 19.8855C22.7189 20.3856 22.0406 20.6666 21.3333 20.6666H16V3.33325H21.3333C22.0406 3.33325 22.7189 3.6142 23.219 4.1143C23.719 4.6144 24 5.29267 24 5.99992V17.9999Z",
    fill: "#CE2B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 3.33325C1.95942 3.33325 1.28115 3.6142 0.781049 4.1143C0.280952 4.6144 0 5.29267 0 5.99992L0 17.9999C0 18.7072 0.280952 19.3854 0.781049 19.8855C1.28115 20.3856 1.95942 20.6666 2.66667 20.6666H8V3.33325H2.66667Z",
    fill: "#009246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.33325H16V20.6666H8V3.33325Z",
    fill: "#EEEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1900_45919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinentEuropeCountryitaly);
export default __webpack_public_path__ + "static/media/Continent=Europe, Country=italy.fbeafce805925e8fc077ba841e8ee010.svg";
export { ForwardRef as ReactComponent };